<template>
  <main
  v-loading="loading">
    <h3 v-html="$t('SelectIndoorUnitModel')" />
    <el-row>
      <el-col :span="9" :offset="6">
        <el-select
        v-model="vmachine"
        placeholder="Select"
        size="large"
        v-if="filterMachine"
        @change="$emit('setIumodel', {'iumodel': {value: vmachine, id: 'last'}})"
        filterable
        :filter-method="filterOptions"
        class="select">
        
          <el-option
          v-for="machine in filterMachine"
          :key="machine.id"
          :label="machine.indoor_unit"
          :value="machine.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="2" :offset="1">
          <el-button 
          @click="openTab(
            'tools-list-compatibility-AC3.php',
            '_blank',`c=${compatibilityType}`,
            `a=${articleType}`,
            `b=${brand}`,
            `s=${search}`)"  
          type="primary"
          v-html="$t('List')" 
          icon="el-icon-collection" />
      </el-col>
    </el-row>
  </main>
</template>

<script>
import CompatibilityServices from '@/api/CompatibilityServices';
import LoaderMixin from '@/mixins/Loader.mixin';

export default {
  name: 'SelectIumodels',
  mixins: [LoaderMixin],
  props: {
    appMarket: {
      type: String,
      default: '',
    },
    appLocale: {
      type: String,
      default: '',
    },
    compatibilityType: {
      type: String,
      default: '',
    },
    articleType: {
      type: String,
      default: '',
    },
    brand: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      machines: [],
      filterMachine:[],
      vmachine: '',
      search:'',
    };
  },
  methods: {
    async getApi() {
      const requestHeaders = {
        headers: {
          'app-market': this.appMarket,
          'app-locale': this.appLocale,
          apiKey: process.env.VUE_APP_APIKEY,
        },
      };
      const response = await CompatibilityServices
        .getIumodels(requestHeaders, this.compatibilityType, this.articleType, this.brand);
      this.machines = response.data.body.iumodels;
      this.filterMachine = this.machines
    },
    changeNum() {
      if (this.compatibilityType === 'AIDOO') {
        this.num = 'last';
      }
    },
    openTab(path = '',target = '_blank', ...params) {
      let query = '';
      if (params.length > 0) {
        query = '?';
        params.forEach((el,key) => {
          query += `${el}`;
          if (key<params.length-1) {
            query += '&';
          }
        });
      }
      window.open(`${window.location.origin}/${path}${query}`,target);
    },
    filterOptions(filterValue) {
      this.search = filterValue;
      // this.machines.forEach(option=>console.log(option));
      this.filterMachine = this.machines.filter(
        option => option.indoor_unit.toUpperCase().includes(filterValue.toUpperCase())
      )
    },
    testee(e) {
      console.log(e);
    }
  },
  mounted() {
    this.getApi();
    
    this.changeNum();
  },
};
</script>

<style scoped lang="scss">

</style>
